import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import ErrorPage from "pages/ErrorPage";
import {vinSearchFilterByWanUrl} from "lib/callBackend";
import _ from "lodash";
import T from "i18n-react";
import {ErrorWrapperWithAppHeader} from "pages/ErrorWrapperWithAppHeader";
import {Backdrop, CircularProgress} from "@mui/material";

const getVinAndWanParams = (location) => {
    const params = new URLSearchParams(location?.search?.replace("&amp;", "&"));
    let wans = params.getAll("wan") || [];

    if (!wans || !wans.length) {
        wans = params.get("wans");
        wans = wans ? wans.split(',') : null;
    }

    return {
        vin: params.get("vin"),
        wans: wans
    };
}

const VIN_LENGTH = 17;
const VIN_OR_SHORT_VIN_REGEXP = /^(X{12}[\dA-Z]{5}|(?!.*X{5})[\dA-Z]{17})$/i

const validateAndGetError = (vin, regExp) => {
    if (!_.isString(vin)) {
        return {key: 'vin.validation.error.required', msg: T.translate('validation.vinErrorRequired')};
    } else if (vin.length < VIN_LENGTH) {
        return {key: 'vin.validation.error.to.short', msg: T.translate('validation.vinErrorToShort')};
    } else if (vin.length > VIN_LENGTH) {
        return {key: 'vin.validation.error.to.long', msg: T.translate('validation.vinErrorToLong')};
    } else if (!vin.match(regExp)) {
        return {key: 'vin.validation.error.regex', msg: T.translate('validation.vinErrorRegex')};
    }

    return null;
};

export const ReportsPageByVinAndWan = (props) => {

    const location = useLocation();
    const params = getVinAndWanParams(location);
    const navigate = useNavigate();
    const vin = typeof params?.vin === 'string' ? params?.vin?.padStart(VIN_LENGTH, 'X').toUpperCase() : '';
    const [vinSearchError, setVinSearchError] = useState(null);
    const [validationError] = useState(validateAndGetError(vin, VIN_OR_SHORT_VIN_REGEXP));
    const [isLoading, setIsLoading] = useState(true);

    const renderPage = () => {
        const validatorError = validateAndGetError(vin, VIN_OR_SHORT_VIN_REGEXP);

        if (validatorError) {
            return <ErrorWrapperWithAppHeader errorMessage={validatorError.msg} reportData={{}} setSelectedDatabases={props.setSelectedDatabases} />;
        }

        if (vinSearchError) {
            const isOrderLimitError = vinSearchError.orderLimitError;
            if (isOrderLimitError) {
                return <ErrorWrapperWithAppHeader vin={vin} reportData={{}} setSelectedDatabases={props.setSelectedDatabases}
                                                  errorMessage={T.translate('vinQueryFilterByWanComponent.recordsNotFoundError')}/>
            }
            return <ErrorPage/>;
        }

        return <ErrorWrapperWithAppHeader vin={vin} reportData={{}} setSelectedDatabases={props.setSelectedDatabases}/>;
    };

    useEffect(() => {
        if (vinSearchError || validationError) {
            setIsLoading(false);
            return;
        }

        vinSearchFilterByWanUrl(vin, params.wans)
            .then(response => {
                setIsLoading(false);
                if (response?.error) {
                    setVinSearchError({
                        error: response.error,
                        orderLimitError: response.orderLimitError || false
                    });
                } else {
                    navigate(`/pages/singleResult`, {
                        state: {
                            vin: vin,
                            reportData: response || {},
                            engineCC: null,
                            firstRegistrationDate: null,
                        }
                    });
                }
            });
    }, [vin, navigate, params, vinSearchError, validationError]);

    return (
        <>
            {renderPage()}
            {isLoading ? <Backdrop sx={{zIndex: 50000}} open={isLoading}>
                    <CircularProgress color={'primary'} size={150}/>
                </Backdrop> : null}
        </>
    );
};